/* eslint-disable eag/match-named-export */

export type GetCustomerPaymentApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      allowBankTransfer?: boolean | null;
      invoiceMaturity?: number | null;
      paymentLimit?: number | null;
      email?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerPaymentApiArg = {
  customerId: string;
};
export type PostCustomerPaymentApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerPaymentApiArg = {
  customerId: string;
  body: {
    allowBankTransfer: boolean;
    invoiceMaturity?: number | null;
    paymentLimit?: number | null;
    email?: string | null;
  } | null;
};
export type PatchCustomerPaymentApiResponse = /** status 204 Standard response */ undefined;
export type PatchCustomerPaymentApiArg = {
  customerId: string;
  body: {
    allowBankTransfer: boolean;
    invoiceMaturity?: number | null;
    paymentLimit?: number | null;
    email?: string | null;
  } | null;
};
